/* src/students/cards/StudentCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import { get, isEmpty, find } from 'lodash';
import { loadTexts } from '../../../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  CardActions,
  Collapse,
  Divider,
  Menu,
  MenuItem,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { BorderColor, ExpandMore } from '@material-ui/icons';
import { formatDate } from '../../../../util';

import {
  ConfirmationPopup,
  DisabledPage,
  SimpleTable,
  HeaderTable,
  TabBar,
} from '../../../../app/components';
import {
  ReviewsTable,
  UserContent,
  UserHeader,
  Notes,
} from '../../../../app/components/user';

import LessonCard from '../../../lessons/cards/LessonCard';

import styles from './styles';

import {
  fetchStudent,
  fetchStudents,
  addCredits,
  removeStudent,
  clearSelectedStudent,
} from '../../actions';
import {
  addNote,
  removeNote,
  setReviewVisibility,
} from '../../../tutors/actions';
import { fetchUserLesson } from '../../../lessons/actions';
import { lessonSetInfo } from '../../../lessons/cards/LessonCard/actions';

import {
  getSelected,
  fetchStudentState,
  getNotesList,
  getLessons,
  getReviewsList,
  getReviewsData,
  getAnalyticsData,
  getPaymentInfo,
  getPaymentErrors,
  getFeedbackList,
} from '../../selectors';

import { getLessonInfo } from '../../../tutors/selectors';

//
// const transactionHistory = [
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
// ];
const TEXT_KEY = 'students';

class StudentCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      value: 0,
      expandedReview: false,
      openLesson: false,
      openNotes: false,
      openDeleteConfirmation: false,
      openAddCredits: false,
      amount: 0,
      anchorEl: null,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._onToggleExpand = this._onToggleExpand.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._onToggleNotes = this._onToggleNotes.bind(this);
    this._onToggleLesson = this._onToggleLesson.bind(this);
    this._onClickVisibility = this._onClickVisibility.bind(this);

    this._onAddNote = this._onAddNote.bind(this);
    this._onRemoveNote = this._onRemoveNote.bind(this);

    this._onCloseAddCreditsPopup = this._onCloseAddCreditsPopup.bind(this);
    this._onOpenAddCreditsPopup = this._onOpenAddCreditsPopup.bind(this);
    this._onClickAddCredits = this._onClickAddCredits.bind(this);
    this._onChangeAmount = this._onChangeAmount.bind(this);

    this._onRefundStudent = this._onRefundStudent.bind(this);

    this._onCloseUserMenu = this._onCloseUserMenu.bind(this);
    this._onOpenUserMenu = this._onOpenUserMenu.bind(this);
    this._onCloseDeleteConfirmation = this._onCloseDeleteConfirmation.bind(
      this,
    );
    this._onOpenDeleteConfirmation = this._onOpenDeleteConfirmation.bind(this);
    this._onDeleteStudent = this._onDeleteStudent.bind(this);
  }

  async componentDidMount() {
    const { tasks } = this.props;
    if (isEmpty(tasks)) return;
    for (let task of tasks) {
      switch (task.action) {
        case 'fetch':
          await this.props.fetchStudent({ student: task.payload });
          break;
        case 'tab':
          await new Promise(resolve => {
            let value = 0;
            switch (task.payload) {
              case 'lessons':
                value = 0;
                break;
              case 'analytics':
                value = 1;
                break;
              case 'reviews':
                value = 2;
                break;
              case 'feedback':
                value = 3;
                break;
              case 'payment':
                value = 4;
                break;
              default:
                value = 0;
            }
            this.setState({ value }, () => {
              resolve();
            });
          });
          break;
        case 'expand_review':
          await new Promise(resolve => {
            this.setState({ expandedReview: task.payload }, () => {
              resolve();
            });
          });
          break;
        default:
          break;
      }
    }
  }

  _onToggleExpand() {
    this.setState({ expanded: !this.state.expanded });
  }

  _handleChange(event, value) {
    this.setState({ value });
  }

  _onToggleLesson(type) {
    return async data => {
      if (type) {
        await this.props.fetchUserLesson({ lesson: data._id });
        this.props.lessonSetInfo(this.props.lessonInfo);
      }
      this.setState({ openLesson: type });
    };
  }

  _onToggleNotes(type) {
    return () => this.setState({ openNotes: type });
  }

  async _onAddNote(text) {
    await this.props.addNote({
      noteInput: {
        _user: this.props.student._id,
        body: text,
      },
    });

    this.props.fetchStudent({ student: this.props.student._id });
  }

  async _onRemoveNote(note) {
    await this.props.removeNote({ note: note._id });
    this.props.fetchStudent({ student: this.props.student._id });
  }

  async _onClickVisibility(review) {
    await this.props.setReviewVisibility({
      review: review._id,
      visible: !review.visible,
    });
    this.props.fetchStudent({ student: this.props.student._id });
  }

  _onOpenAddCreditsPopup() {
    this.setState({ openAddCredits: true });
  }

  _onCloseAddCreditsPopup() {
    this.setState({ openAddCredits: false });
  }

  _onRefundStudent() {
    this.props.fetchStudent({ student: this.props.student._id });
  }

  async _onClickAddCredits() {
    const { amount } = this.state;
    await this.props.addCredits({ student: this.props.student._id, amount });
    this.setState({ amount: 0, openAddCredits: false });
    this.props.fetchStudent({ student: this.props.student._id });
  }

  _onChangeAmount(event) {
    this.setState({ amount: event.target.value });
  }

  _onCloseUserMenu() {
    this.setState({ anchorEl: null });
  }

  _onOpenUserMenu(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  _onCloseDeleteConfirmation() {
    this.setState({ openDeleteConfirmation: false });
  }

  _onOpenDeleteConfirmation() {
    this.setState({ openDeleteConfirmation: true, anchorEl: null });
  }

  _onFetchStudents() {
    const { selectedUniversity, selectedOrganization } = this.props;
    this.props.fetchStudents({ studentSearchInput: {
      _universities: [selectedUniversity],
      _organizations: [selectedOrganization],
    } });
  }

  async _onDeleteStudent() {
    this.setState({ openDeleteConfirmation: false });
    await this.props.removeStudent({ student: this.props.student._id });
    this._onFetchStudents();
    this.props.clearSelectedStudent();
  }

  renderExpandButton(classes, expanded) {
    return (
      <IconButton
        className={classNames(classes.expand, {
          [classes.expandOpen]: expanded,
        })}
        aria-expanded={expanded}
        aria-label="Show more"
        onClick={this._onToggleExpand}
      >
        <ExpandMore />
      </IconButton>
    );
  }

  render() {
    const {
      classes,
      student: { name, email, phone, active, bio, avatar, empty },
      notes,
      lessons,
      reviews,
      reviewsData,
      feedback,
      analyticsData,
      paymentInfo,
      paymentErrors,
      organizations
    } = this.props;
    const {
      expanded,
      value,
      openLesson,
      openNotes,
      openAddCredits,
      openDeleteConfirmation,
      amount,
      anchorEl,
      texts,
    } = this.state;

    const renderCredits = !isEmpty(find(organizations, o => o.name === 'Nimbus'));

    return (
      <React.Fragment>
        <Card className={classes.card}>
          {!empty && (
            <React.Fragment>
              <UserHeader
                active={active}
                onMoreActions={this._onOpenUserMenu}
                name={name}
                email={email}
                phone={phone}
                src={avatar}
              />
              <Menu
                id="student-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this._onCloseUserMenu}
              >
                <MenuItem onClick={this._onOpenDeleteConfirmation}>
                  <Typography color="secondary">{texts.profile.delete}</Typography>
                </MenuItem>
              </Menu>
              <CardActions classes={{ root: classes.moreInfo }}>
                <Tooltip id="notes" title={texts.profile.notes}>
                  <IconButton
                    aria-label="Notes"
                    onClick={this._onToggleNotes(true)}
                  >
                    <BorderColor />
                  </IconButton>
                </Tooltip>
                {/* }<Tooltip id="message" title="Message">
                  <IconButton aria-label="Message"><Message /></IconButton>
                </Tooltip> */}
                {this.renderExpandButton(classes, expanded)}
              </CardActions>
              <Divider />
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <UserContent bio={bio} education={[]} />
              </Collapse>
              <TabBar
                value={value}
                onChange={this._handleChange}
                labels={[
                  texts.profile.labels.lessons,
                  texts.profile.labels.analytics,
                  texts.profile.labels.reviews,
                  texts.profile.labels.feedback,
                  texts.profile.labels.payment,
                ]}
              />
              {value === 0 && (
                <HeaderTable
                  data={lessons}
                  hover
                  onRowClick={this._onToggleLesson(true)}
                />
              )}
              {value === 1 && <SimpleTable data={analyticsData} />}
              {value === 2 && (
                <React.Fragment>
                  <SimpleTable data={reviewsData} gutterBottom />
                  <ReviewsTable
                    data={reviews}
                    type="student"
                    onClickVisibility={this._onClickVisibility}
                    expanded={this.state.expandedReview}
                  />
                </React.Fragment>
              )}
              {value === 3 && (
                <ReviewsTable
                  data={feedback}
                  onClickVisibility={this._onClickVisibility}
                  expanded={this.state.expandedReview}
                  type="tutor"
                />
              )}
              {value === 4 && (
                <React.Fragment>
                  <SimpleTable
                    data={paymentInfo}
                    footerStyle={classes.footerStyle}
                  />
                  {renderCredits &&
                  (<Button color="primary" onClick={this._onOpenAddCreditsPopup}>
                    {texts.profile.labels.add_credits}
                  </Button>)
                  }
                  <SimpleTable
                    data={paymentErrors}
                    header="Errors"
                    gutterBottom
                    hover
                  />
                  {/*<SimpleTable
                    data={transactionHistory}
                    header="Transaction History"
                    hover
                  />*/}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Card>
        <LessonCard
          open={openLesson}
          onClose={this._onToggleLesson(false)}
          onRefundStudent={this._onRefundStudent}
        />
        <Notes
          open={openNotes}
          onClose={this._onToggleNotes(false)}
          onAdd={this._onAddNote}
          onRemove={this._onRemoveNote}
          notes={notes}
        />
        <ConfirmationPopup
          open={openAddCredits}
          title={texts.profile.labels.add_credits}
          subtitle={texts.profile.popups.subtitle1}
          affirmativeButtonText={texts.profile.popups.button_text.add}
          onClose={this._onCloseAddCreditsPopup}
          onSubmit={this._onClickAddCredits}
          content={() => (
            <TextField
              id="add_credits_amount"
              value={amount}
              onChange={this._onChangeAmount}
              fullWidth
              label={texts.profile.popups.button_text.amount}
              type="number"
            />
          )}
        />
        <ConfirmationPopup
          open={openDeleteConfirmation}
          title={texts.profile.popups.title}
          subtitle={texts.profile.popups.subtitle2}
          affirmativeButtonText={texts.profile.popups.button_text.confirm}
          onClose={this._onCloseDeleteConfirmation}
          onSubmit={this._onDeleteStudent}
        />
      </React.Fragment>
    );
  }
}

StudentCard.propTypes = {
  classes: PropTypes.object.isRequired,
  student: PropTypes.object.isRequired,
  notes: PropTypes.array.isRequired,
  addNote: PropTypes.func.isRequired,
  removeNote: PropTypes.func.isRequired,
  fetchStudent: PropTypes.func.isRequired,
  lessons: PropTypes.array.isRequired,
  reviews: PropTypes.array.isRequired,
  feedback: PropTypes.array.isRequired,
  reviewsData: PropTypes.array.isRequired,
  analyticsData: PropTypes.array.isRequired,
  paymentInfo: PropTypes.array.isRequired,
  paymentErrors: PropTypes.array.isRequired,
  fetchUserLesson: PropTypes.func.isRequired,
  lessonSetInfo: PropTypes.func.isRequired,
  setReviewVisibility: PropTypes.func.isRequired,
  addCredits: PropTypes.func.isRequired,
  removeStudent: PropTypes.func.isRequired,
  lessonInfo: PropTypes.object.isRequired,
  fetchStudents: PropTypes.func.isRequired,
  clearSelectedStudent: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  student: getSelected(state),
  fetchState: fetchStudentState(state),
  notes: getNotesList(state),
  lessons: getLessons(state),
  lessonInfo: getLessonInfo(state),
  reviews: getReviewsList(state),
  feedback: getFeedbackList(state),
  reviewsData: getReviewsData(state),
  analyticsData: getAnalyticsData(state),
  paymentInfo: getPaymentInfo(state),
  paymentErrors: getPaymentErrors(state),
  tasks: get(state, 'router.location.state.tasks') || [],
  organizations: get(state, 'auth.data.user.organizations') || [],
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchUserLesson: params => dispatch(fetchUserLesson(params)()),
  lessonSetInfo: params => dispatch(lessonSetInfo(params)),
  addNote: params => dispatch(addNote(params)()),
  removeNote: params => dispatch(removeNote(params)()),
  fetchStudent: params => dispatch(fetchStudent(params)()),
  fetchStudents: params => dispatch(fetchStudents(params)()),
  setReviewVisibility: params => dispatch(setReviewVisibility(params)()),
  addCredits: params => dispatch(addCredits(params)()),
  removeStudent: params => dispatch(removeStudent(params)()),
  clearSelectedStudent: () => dispatch(clearSelectedStudent()),
});

export default compose(
  withStyles(styles, { name: 'StudentCard' }),
  connect(mapStateToProps, mapDispatchToProps),
)(StudentCard);



// WEBPACK FOOTER //
// ./src/modules/students/cards/StudentCard/index.js